module.exports = __webpack_public_path__ + "img/info-icon.376b213f.svg";